import { render, staticRenderFns } from "./CbsBpmInbox.vue?vue&type=template&id=7cda7e20"
import script from "./CbsBpmInbox.vue?vue&type=script&lang=js"
export * from "./CbsBpmInbox.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports